const A = "/brand";
const IMG = `${A}/blueprint4joy-visionbook-hero-redblazer.jpg`;
const ALT = "Lara in a red coat, laughing as she looks down at her open Vision Book, against a bright architectural white wall.";

const btnPrimary =
  "inline-flex items-center justify-center gap-2 bg-[#FF5A4F] text-white rounded-[8px] px-7 py-3.5 text-base font-medium hover:bg-[#e8463c] transition-colors";

export function VisionBookHero() {
  return (
    <section
      data-testid="vbw-hero-section"
      className="relative w-full overflow-hidden bg-[#FAFAF8]"
      style={{ minHeight: "min(88vh, 760px)" }}
    >
      {/* Homepage text-over-image pattern (HomeHero.jsx): the photo is the
          full-bleed section background; copy is overlaid directly on the
          image's own safe negative space (the plain wall to Lara's left).
          Object-position is bottom/right-biased so any crop trims empty
          wall first — her face, hands and the open book stay fully in
          frame at every breakpoint. */}
      <img
        src={IMG}
        alt={ALT}
        data-testid="vbw-hero-image"
        className="absolute inset-0 w-full h-full object-cover object-[82%_78%] sm:object-[72%_75%] lg:object-[62%_72%]"
      />
      <div className="relative z-[2] max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20 min-h-[inherit] flex items-center">
        <div className="max-w-md lg:max-w-lg reveal">
          <p className="text-xs tracking-[0.24em] uppercase text-[#159E9A] mb-4">
            Vision Book Workshop
          </p>
          <h1
            data-testid="vbw-hero-headline"
            className="font-display text-[30px] sm:text-[38px] lg:text-[44px] leading-[1.12] tracking-tight text-[#1C1917]"
          >
            What if the life you&rsquo;re longing for has been leaving clues
            all along?
          </h1>
          <div className="mt-6 space-y-3 text-[16px] md:text-[17px] leading-relaxed text-[#57534E]">
            <p>Sometimes we know something wants to change.</p>
            <p>We simply can&rsquo;t see it clearly yet.</p>
            <p>
              Sometimes we know we&rsquo;re hurting but can&rsquo;t imagine what
              healing could look like.
            </p>
            <p>Sometimes a dream quietly refuses to leave us alone.</p>
            <p>
              A Vision Book creates space to notice what your heart has been
              trying to tell you before life gets loud again.
            </p>
            <p>Not to become someone else.</p>
            <p className="text-[#1C1917]">
              To recognize what has been quietly calling you forward all
              along.
            </p>
          </div>
          <div className="mt-7">
            <a
              href="#workshop-options"
              data-testid="vbw-hero-cta"
              className={btnPrimary}
            >
              Create My Vision Book
            </a>
          </div>
          <p className="mt-5 text-sm md:text-base text-[#8A8580] italic max-w-sm">
            A Vision Book isn&rsquo;t about predicting your future. It&rsquo;s
            about recognizing it when it whispers.
          </p>
        </div>
      </div>
    </section>
  );
}
